export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              焦点专题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              深度内容策划，每期精选热门主题，带你发现更多好内容
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20living%20room%20scene%20with%20a%20large%20TV%20screen%20showing%20colorful%20movie%20posters%2C%20cozy%20atmosphere%2C%20popcorn%20bowl%20on%20coffee%20table%2C%20soft%20ambient%20lighting%2C%20movie%20night%20vibe%2C%20cinematic%20warm%20tones%2C%20home%20entertainment%20aesthetic&width=800&height=600&seq=douhua-carousel-1&orientation=landscape"
                  alt="周末追剧指南：五部必看品质大剧"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 mb-2 whitespace-nowrap">编辑精选</span>
                  <h3 className="text-base font-semibold text-background-50">周末追剧指南：五部必看品质大剧</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">精选香蕉视频、红桃视频平台最近上线的口碑大剧，涵盖古装、都市、悬疑多种题材，让你的周末充实而精彩。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylish%20movie%20theater%20interior%20with%20red%20velvet%20seats%2C%20dim%20warm%20lighting%2C%20large%20screen%20showing%20action%20scene%2C%20cinematic%20atmosphere%2C%20premium%20viewing%20experience%2C%20warm%20golden%20and%20amber%20tones%2C%20vintage%20theater%20charm&width=800&height=600&seq=douhua-carousel-2&orientation=landscape"
                  alt="动作片爱好者必收：年度十大高燃打斗场面"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-2 whitespace-nowrap">热门专题</span>
                  <h3 className="text-base font-semibold text-background-50">动作片爱好者必收：年度十大高燃场面</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">蜜桃视频和西瓜视频平台动作大片精彩集锦，从极速追车到拳拳到肉，每一个镜头都让人热血沸腾。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautiful%20traditional%20Chinese%20palace%20garden%20with%20cherry%20blossoms%2C%20ancient%20architecture%20in%20background%2C%20flowing%20silk%20robes%2C%20soft%20golden%20sunlight%2C%20romantic%20historical%20atmosphere%2C%20period%20drama%20aesthetic%2C%20warm%20and%20elegant%20color%20palette&width=800&height=600&seq=douhua-carousel-3&orientation=landscape"
                  alt="古装剧迷福利：服化道最精美的十部作品"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-500 text-background-50 mb-2 whitespace-nowrap">深度策划</span>
                  <h3 className="text-base font-semibold text-background-50">古装剧迷福利：服化道最精美的十部作品</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">从《长安锦绣》到多部经典古装传奇剧，盘点那些让人过目不忘的精美服饰和场景设计，视觉盛宴不容错过。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20bedroom%20at%20night%20with%20string%20lights%2C%20laptop%20screen%20glowing%2C%20person%20wrapped%20in%20blanket%20watching%20drama%2C%20warm%20and%20intimate%20atmosphere%2C%20late%20night%20binge%20watching%20vibe%2C%20soft%20warm%20lighting%2C%20comfort%20aesthetic&width=800&height=600&seq=douhua-carousel-4&orientation=landscape"
                  alt="深夜追剧必备：高能悬疑剧让大脑飞速运转"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 mb-2 whitespace-nowrap">编辑精选</span>
                  <h3 className="text-base font-semibold text-background-50">深夜追剧必备：高能悬疑剧让大脑飞速运转</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">红桃视频和樱桃视频平台悬疑推理剧精选合集，烧脑剧情、反转不断，最适合夜深人静时一口气追完。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20family%20gathering%20around%20a%20TV%2C%20laughter%20and%20joy%2C%20colorful%20living%20room%2C%20kids%20and%20adults%20enjoying%20together%2C%20warm%20daylight%20streaming%20through%20windows%2C%20happy%20family%20entertainment%2C%20bright%20and%20cheerful%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=douhua-carousel-5&orientation=landscape"
                  alt="全家一起看：适合各年龄段的优质合家欢内容"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-2 whitespace-nowrap">热门专题</span>
                  <h3 className="text-base font-semibold text-background-50">全家一起看：适合各年龄段的优质合家欢内容</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">糖豆视频和蘑菇视频平台精选亲子动画和家庭剧，让每个家庭成员都能找到自己的快乐时光。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20and%20tablet%20on%20a%20wooden%20desk%2C%20displaying%20colorful%20video%20content%20grids%2C%20coffee%20cup%20nearby%2C%20natural%20window%20light%2C%20digital%20streaming%20lifestyle%2C%20clean%20minimal%20composition%2C%20warm%20morning%20light%2C%20tech%20and%20entertainment%20aesthetic&width=800&height=600&seq=douhua-carousel-6&orientation=landscape"
                  alt="通勤路上不无聊：移动端追剧高效方法论"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-500 text-background-50 mb-2 whitespace-nowrap">深度策划</span>
                  <h3 className="text-base font-semibold text-background-50">通勤路上不无聊：移动端追剧高效方法论</h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-foreground-600 leading-relaxed">豆花视频为你总结最适合碎片时间观看的短剧和精华片段，地铁公交上的每一分钟都不再虚度。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}